import { setWellandToken } from './storageKeys';

export const WELLAND_ACCESS_TOKEN_EVENT = 'welland-access-token';

export function persistAndBroadcastAccessToken(token) {
    if (!token || typeof token !== 'string') return;
    setWellandToken(token);
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(WELLAND_ACCESS_TOKEN_EVENT, { detail: { token } }));
    }
}
